import React, { useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Menu = ({
  anchorEl,
  open,
  onClose,
  children,
  handleView,
  handleDetails,
  handleDelete,
  handleEdit,
  cardType,
  status,
  handleStatus,
  sorted,
  handleSort,
}) => {
  const menuRef = useRef();
  const scrollRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, onClose]);

  useEffect(() => {
    if (scrollRef.current) {
      const rect = scrollRef.current.getBoundingClientRect();
      if (rect.bottom > window.innerHeight) {
        scrollRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
      }
    }
  }, [open]);

  const isButtonAtBottom = () => {
    if (anchorEl) {
      const rect = anchorEl.getBoundingClientRect();
      return rect.bottom >= window.innerHeight;
    }
    return false;
  };

  const getMenuPosition = () => {
    if (anchorEl) {
      const rect = anchorEl.getBoundingClientRect();
      const parentRect = menuRef.current.parentElement.getBoundingClientRect();
      return {
        top: isButtonAtBottom() ? "auto" : rect.bottom - parentRect.top,
        bottom: isButtonAtBottom() ? 0 : "auto",
        left:
          rect.left -
          parentRect.left -
          parseFloat(getComputedStyle(document.documentElement).fontSize) * 6,
      };
    }
    return { top: 0, left: 0 };
  };

  const { top, bottom, left } = getMenuPosition();

  return (
    <div
      ref={menuRef}
      className="rounded-lg z-50 absolute"
      style={{
        display: open ? "block" : "none",
        position: "absolute",
        top: top,
        bottom: bottom,
        right: "5%",
        backgroundColor: "white",
        boxShadow: "2px 2px 10px rgba(0,0,0,0.1)",
        zIndex: 1000,
      }}
    >
      <div className=" flex flex-col gap-4 w-52 p-4 relative ">
        {/* <button onClick={handleView}>View Applicants</button> */}
        <button
          onClick={() => {
            handleEdit();
            onClose();
          }}
          className="mr-auto"
        >
          Edit
        </button>
        {cardType !== "resumeCard" && (
          <button
            onClick={() => {
              handleStatus();
              onClose();
            }}
            className="mr-auto"
          >
            {" "}
            {status ? "Close" : "Open"}{" "}
            {cardType === "jobPostCard"
              ? "Job Post"
              : cardType === "interviewCard"
              ? "Interview"
              : cardType === "mcqCard"
              ? "MCQ"
              : ""}
          </button>
        )}
        {sorted && cardType === "resumeCard" && (
          <button
            className="mr-auto"
            onClick={() => {
              handleSort();
              onClose();
            }}
          >
            Sort
          </button>
        )}

        {cardType === "jobPostCard" && (
          <button
            onClick={() => {
              handleDetails();
              onClose();
            }}
            className="mr-5 whitespace-nowrap pr-12"
          >
            View Job Details
          </button>
        )}
        {cardType === "interviewCard" && (
          <button
            onClick={() => {
              handleDetails();
              onClose();
            }}
            className="mr-6 whitespace-nowrap pr-2"
          >
            View Interview Details
          </button>
        )}

        <button
          onClick={() => {
            handleDelete();
            onClose();
          }}
          className="mr-auto"
        >
          Delete
        </button>
      </div>
      <div className="" ref={scrollRef}></div>
    </div>
  );
};

const MenuItem = ({ onClick, children }) => {
  return (
    <div
      onClick={onClick}
      style={{
        padding: "8px 16px",
        cursor: "pointer",
      }}
    >
      {children}
    </div>
  );
};

export { Menu, MenuItem };
